export default "__VITE_ASSET__BypT8NEu__"